import { CCol, CContainer, CRow } from '@coreui/react';
import React from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import bootstrap from './bootstrap.svg'
import js from './js.svg'
import material from './materialui.svg'
import mongo from './mongodb.svg'
import node from './node.svg'
import react from './react.svg'
import tailwind from './tailwind.svg'
import typescript from './typescript.svg'
import './skill.css'

const Skill = () => {
    AOS.init({
        // Global settings:
        disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
        startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
        initClassName: 'aos-init', // class applied after initialization
        animatedClassName: 'aos-animate', // class applied on animation
        useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
        disableMutationObserver: false, // disables automatic mutations' detections (advanced)
        debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
        throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
        
      
        // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
        offset: 120, // offset (in px) from the original trigger point
        delay: 0, // values from 0 to 3000, with step 50ms
        duration: 1000, // values from 0 to 3000, with step 50ms
        easing: 'ease', // default easing for AOS animations
        once: false, // whether animation should happen only once - while scrolling down
        mirror: false, // whether elements should animate out while scrolling past them
        anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
      
      });
    return (
        <div style={{ backgroundColor:'#2C3E50'}}>
            <h1 className="text-center pt-4 text-white mx-auto" >Skills</h1>
            <div className="mx-auto pb-2 mb-3" style={{borderBottom:'4px solid #28B463', width:'200px', zIndex:'10'}}></div>
           <CContainer>
               <CRow className="skills">
                   <CCol sm={6} md={3}>
                     <div className="item">
                     <img data-aos="zoom-in" className="img-fluid" src={bootstrap} alt="" /> 
                     <h2 className="text-center text-white mt-2">Bootstrap</h2>
                       </div>           
                   </CCol>
                   <CCol sm={6} md={3}>
                     <div className="item">
                     <img data-aos="zoom-in" className="img-fluid" src={js} alt="" /> 
                     <h2 className="text-center text-white mt-2">JavaScript</h2>
                       </div>           
                   </CCol>
                   <CCol sm={6} md={3}>
                     <div className="item">
                     <img data-aos="zoom-in" className="img-fluid" src={material} alt="" /> 
                     <h2 className="text-center text-white mt-2">Material UI</h2>
                       </div>           
                   </CCol>
                   <CCol sm={6} md={3}>
                     <div className="item">
                     <img data-aos="zoom-in" className="img-fluid" src={mongo} alt="" /> 
                     <h2 className="text-center text-white mt-2">MongoDB</h2>
                       </div>           
                   </CCol>
                   <CCol sm={6} md={3}>
                     <div className="item">
                     <img data-aos="zoom-in" className="img-fluid" src={node} alt="" /> 
                     <h2 className="text-center text-white mt-2">NodeJS</h2>
                       </div>           
                   </CCol>
                   <CCol sm={6} md={3}>
                     <div className="item">
                     <img data-aos="zoom-in" className="img-fluid" src={react} alt="" /> 
                     <h2 className="text-center text-white mt-2">ReactJS</h2>
                       </div>           
                   </CCol>
                   <CCol sm={6} md={3}>
                     <div className="item">
                     <img data-aos="zoom-in" className="img-fluid" src={tailwind} alt="" /> 
                     <h2 className="text-center text-white mt-2">TailWindCSS</h2>
                       </div>           
                   </CCol>
                   <CCol sm={6} md={3}>
                     <div className="item">
                     <img data-aos="zoom-in" className="img-fluid" src={typescript} alt="" /> 
                     <h2 className="text-center text-white mt-2">TypeScript</h2>
                       </div>           
                   </CCol>
                   
               </CRow>
           </CContainer>
        </div>
    );
};

export default Skill;